/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import {
  AccountManagementProvider,
  PageSkeleton,
  PersonalDetailsPage,
} from "@farmlands/account-management";
import { AppError } from "@farmlands/ui-library";
import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { PageContainer } from "../../../components/layout/PageContainer";
import { useThemeBackgroundColor } from "../../../hooks/useThemeBackgroundColor";
import { useAccountManagementContextValue } from "../hooks/useAccountManagementContextValue";

import DeleteAccountCard from "./components/DeleteAccountCard/DeleteAccountCard";

export const PersonalDetailsRouter: FC = () => {
  useThemeBackgroundColor((theme) => theme.colors.shade0);

  const { contextValue, isLoading, error, refetch } = useAccountManagementContextValue({
    userScoped: true,
  });

  if (isLoading) {
    return (
      <PageContainer>
        <PageSkeleton />
      </PageContainer>
    );
  }

  if (error || !contextValue.account.selectedAccount) {
    return <AppError contactUrl={contextValue.config.contactUrl} onTryAgainClick={refetch} />;
  }

  return (
    <AccountManagementProvider value={contextValue}>
      <PageContainer>
        <Routes>
          <Route
            index
            element={
              <PersonalDetailsPage>
                <DeleteAccountCard />
              </PersonalDetailsPage>
            }
          />
          <Route path="*" element={<Navigate to=".." replace relative="path" />} />
        </Routes>
      </PageContainer>
    </AccountManagementProvider>
  );
};

export default PersonalDetailsRouter;
